import { FC } from "react";
import { ChipProps, Stack } from "@mui/material";
import Chip from "@mui/material/Chip";
import { CommitmentState } from "@/services/cloudchipr.api";
import { ProviderUniqueIdCell } from "@/components/pages/commtiments/common/components/data-grid/cells/ProviderUniqueIdCell";

interface CommitmentIdentifierCellHeaderProps {
  id: string;
  state?: CommitmentState;
}

export const CommitmentIdentifierCell: FC<
  CommitmentIdentifierCellHeaderProps
> = ({ id, state }) => {
  return (
    <Stack direction="row" spacing={0.5} alignItems="center" overflow="hidden">
      <ProviderUniqueIdCell id={id ?? ""} />
      {state && (
        <Chip
          label={stateLabels[state].label ?? ""}
          variant="outlined"
          color={stateLabels[state].color}
          size="small"
        />
      )}
    </Stack>
  );
};

const stateLabels: Record<
  CommitmentState,
  { label: string; color: ChipProps["color"] }
> = {
  active: {
    label: "Active",
    color: "success",
  },
  expired: {
    label: "Expired",
    color: "default",
  },
  expires_soon: {
    label: "Expires soon",
    color: "warning",
  },
};
